module.exports = __webpack_public_path__ + "static/media/icon-not-found.fd203f43.png";